import React, { Component } from 'react';
import { findIndex } from 'lodash';
import PropTypes from 'prop-types';

import { getEventDates, getEventMonths } from '../../../utils/formatting';
import Description from '../../text/Description';
import { LinkAnchor } from '../../Links';
import { getEventRedirectUrl, getUseAnchorForEventLink } from '../../../utils/events';
import BackgroundImage from '../../BackgroundImage';

const _ = { findIndex };

class FeaturedEventCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dimensions: null,
        };
        this.refCallback = this.refCallback.bind(this);
    }

    refCallback(element) {
        if (element) {
            this.setState({
                dimensions: element.getBoundingClientRect(),
            });
        }
    }

    render() {
        const { force = {}, auth, 'data-testid': dataTestId } = this.props;
        const { id, name, published, registeredCount, eventDirectors, eventState, eventLocations, utrType, currentMember, photoImages, source } = this.props.event;
        const { eventSchedule } = this.props.event;

        const locationCityStateZip = (eventLocations && eventLocations.length > 0) ? eventLocations[0].display || eventLocations[0].placeName : null;

        let eventName = name;
        let eventNameLength = 35;
        if (this.state.dimensions && this.state.dimensions.width) {
            if (this.state.dimensions.width > 300) {
                eventNameLength += 2 * parseInt((this.state.dimensions.width - 300) / 10);
            }
        }
        if (eventName.length > eventNameLength) {
            eventName = `${eventName.substr(0, eventNameLength)}...`;
        }
        const descriptionItems = [locationCityStateZip];
        if (registeredCount > 0 && !force.hideRegisteredCount) {
            descriptionItems.push(`${registeredCount} playing`);
        }
        const isPlaying = currentMember && (currentMember.playing || currentMember.isPlaying);
        const isOrganizer = (auth && auth.user && auth.user.id && eventDirectors && (_.findIndex(eventDirectors, { memberId: auth.user.id }) !== -1)) || (currentMember && currentMember.eventDirectorRole);

        const getTag = (block, tagPrefix) => {
            if (!published) {
                return <div className={`tag tag-gray tag-sm ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Draft</div>;
            }
            if (isPlaying && isOrganizer) {
                return (
                    <React.Fragment>
                        <div className={`tag tag-${colorState()} tag-sm mr8`} data-testid={tagPrefix && `${tagPrefix}.player-tag`}>Player</div>
                        <div className={`tag tag-${colorState()} tag-sm`} data-testid={tagPrefix && `${tagPrefix}.organizer-tag`}>Organizer</div>
                    </React.Fragment>
                );
            }
            if (isPlaying) {
                return <div className={`tag tag-${colorState()} tag-sm ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.player-tag`}>Player</div>;
            }
            if (isOrganizer) {
                return <div className={`tag tag-${colorState()} tag-sm ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.organizer-tag`}>Organizer</div>;
            }
            switch (eventState.value) {
                case 'pre_registration':
                    return <div className={`tag tag-gray-outline tag-sm ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Pre Reg</div>;
                case 'open_registration':
                    return <div className={`tag tag-teal-outline tag-sm ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Open</div>;
                case 'registration_closed':
                    return <div className={`tag tag-green-outline tag-sm ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Closed</div>;
                case 'in_progress':
                    return <div className={`tag tag-green-outline tag-sm ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>In Progress</div>;
                case 'completed':
                    return <div className={`tag tag-gray-outline tag-sm ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Completed</div>;
                default:
                    return <div />;
            }
        };

        const colorState = () => {
            switch (eventState.value) {
                case 'pre_registration':
                case 'completed':
                    return 'gray';
                case 'registration_closed':
                case 'in_progress':
                    return 'green';
                default:
                    return 'teal';
            }
        };

        const hasBackgroundImage = () => {
            return !!(photoImages.default || photoImages.dashboard.oneX);
        };

        return (
            <LinkAnchor link={getEventRedirectUrl(id, source)} useAnchor={getUseAnchorForEventLink(source)} target={'_self'} data-testid={dataTestId && `${dataTestId}.card-link`}>
                <div className={`utr-card event-card event-card-featured ${hasBackgroundImage() ? 'has-background-image' : ''}`}>
                    <div
                        className={`card-view left-gradiant ${colorState()} ${force && force.small ? 'card-small' : ''}`}
                        ref={this.refCallback}
                    >

                        <div className="d-flex flex-row">
                            <div className="left-column">
                                <div className="tag-container mb-auto">
                                    <div className={`tag tag-featured tag-sm mr8`} data-testid={dataTestId && `${dataTestId}.featured-tag`}>Featured</div>
                                    {getTag(false, dataTestId)}
                                </div>
                                {/* club && club.name && !(force && force.small) && (
                                    <div className="club-name show-ellipsis mb8">
                                        {club.name}
                                    </div>
                                ) */}
                                <div className="h6 event-name" data-testid={dataTestId && `${dataTestId}.name`}>
                                    {eventName}<span className={`${utrType && utrType.value === 'sanctioned' ? 'sanctioned' : ''}`} />
                                </div>
                                {!(force && force.small) && (
                                    <div className="event-details show-ellipsis" data-testid={dataTestId && `${dataTestId}.details`}>
                                        <Description desc={descriptionItems} data-testid={dataTestId && `${dataTestId}.details`} />
                                    </div>
                                )}
                            </div>
                            <div className="right-column">
                                <BackgroundImage
                                    baseUrl={'/v1/tms/events/'}
                                    defaultImage={''}
                                    images={photoImages}
                                    imageType={'dashboard'}
                                    style={{ width: '100%', height: '100%' }}
                                    backgroundOverlay={hasBackgroundImage()}
                                >
                                    <div className={`right-wrapper`}>
                                        <div className="bookmark" />
                                        <div className="event-schedule mt-auto">
                                            <div className="month" data-testid={dataTestId && `${dataTestId}.month`}>
                                                {getEventMonths(eventSchedule)}
                                            </div>
                                            <div className="day" data-testid={dataTestId && `${dataTestId}.day`}>
                                                {getEventDates(eventSchedule)}
                                            </div>
                                        </div>
                                    </div>
                                </BackgroundImage>
                            </div>
                        </div>
                    </div>
                </div>
            </LinkAnchor>
        );
    }
}

FeaturedEventCard.propTypes = {
    auth: PropTypes.objectOf(PropTypes.any).isRequired,
    force: PropTypes.objectOf(PropTypes.any),
    'data-testid': PropTypes.string,
};
FeaturedEventCard.defaultProps = {
    force: {},
    'data-testid': null,
};

export default FeaturedEventCard;
